import { SUMMARY_STATUS } from '@Containers/Summary/constants';

const hasFocusedSummaryState = (summaries, attempt) => summaries.length > 0 || attempt?.status === SUMMARY_STATUS.LOADING;

export default hasFocusedSummaryState;
